// extracted by mini-css-extract-plugin
module.exports = {"button":"Icon_button__1La-f","icon":"Icon_icon__3zA8I"};